import RestaurantMap from './RestaurantMap';

export default RestaurantMap;
